import { ArrowUpRight, FlaskConical } from "lucide-react";

type BetaAlertProps = { supportLink?: string };

// Compact notice: it sits in the login form column and must never push the
// form around nor compete with it.
export const BetaAlert: React.FC<BetaAlertProps> = ({ supportLink = "https://support.yeati.com" }) => {
  const isBetaEnabled = (import.meta.env.VITE_BETA_VERSION ?? import.meta.env.BETA_VERSION) === "true";

  if (!isBetaEnabled) return null;

  return (
    <div className="flex items-start gap-3 rounded-2xl bg-amber-50 px-4 py-3 dark:bg-amber-950/40" data-testid="beta-alert">
      <span className="grid size-8 shrink-0 place-items-center rounded-xl bg-amber-100 text-amber-600 dark:bg-amber-900/60 dark:text-amber-300" aria-hidden>
        <FlaskConical size={16} />
      </span>
      <div className="min-w-0 space-y-1 text-xs leading-5">
        <p className="font-semibold text-gray-900 dark:text-white">
          Version bêta · Expérience anticipée Yeati
        </p>
        <p className="text-gray-600 dark:text-gray-300">
          Préférez l&apos;espace stable ?
          {" "}
          <a
            href={supportLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 font-semibold text-primary hover:underline"
          >
            Accédez à MON-YEATI
            <ArrowUpRight size={16} aria-hidden />
          </a>
        </p>
      </div>
    </div>
  );
};
